// Module
var code = "<script>let $ctrl</script> <div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> <organ-view-panel-data-processing-toms></organ-view-panel-data-processing-toms> </div> <div class=\"flexWrapper__flexContentWrapper--expand-left\"></div> ";
// Exports
module.exports = code;